import { media } from '@/media';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const NewsWrapper = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr 1fr;
  row-gap: 24px;
  column-gap: 40px;

  ${media.mobile`
    display: block;
  `}
`;
